<header>
  <div class=" nav-max">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a class="navbar-brand ml-5" routerLink="/home"><img src="/assets/image/logo.svg" alt="Logo"></a>
        <button class="navbar-toggler navbar-dark" type="button" data-toggle="collapse" data-target="#navbarSupportedContent2" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent2">
          <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
            </li>
            <li class="nav-item">
              <a class="nav-link"  routerLink="/about">About </a>
            </li>
            <li class="nav-item d-lg-none d-block mx-auto mt-4">
              <a class="nav-link btn-orange" href="#">Get a quota</a>
            </li>

          </ul>

        </div>
        <ul class="navbar-nav last-navbar ml-lg-auto ml-0 mb-2 mb-lg-0 user">

          <li class="nav-item">
            <a class="nav-link btn btn-orange" href="#">Get a quota</a>
          </li>
          <li class="nav-item ">
            <a class="nav-link user-fa" href="#"> <i class="far fa-user"></i> </a>
          </li>

        </ul>
      </div>
    </nav>
  </div>
  <!-- navbar start -->


  <!-- navbar end -->

  <!-- hero area start -->
  <section class="hero-area">
    <div class="container ">
      <div class="row">
        <div class="col-xl-5 col-lg-5 col-md-7">
          <div class="hero-body">
            <h2 class="h1 hero-header">Better Coverage in a Fraction of the Time</h2>
            <p>Honeycomb is the only resource you’ll ever need for commercial real estate insurance </p>
            <div class="row my-4">
              <div class="col-xl-6 col-md-6"> <img src="/assets/image/clock.png" class="mb-2 mr-2" alt="clock"> Real-Time Quotes</div>
              <div class="col-xl-6 col-md-6"><img src="/assets/image/savings.png" class="mb-2 mr-2" alt="clock"> Up to 50% Savings</div>
            </div>
            <a href="#" class="btn-orange">Get a Quote</a>
          </div>
        </div>
        <div class=" col-xl-7 col-lg-7 col-md-5"></div>
      </div>
    </div>

  </section>
  <!-- hero area end -->
</header>

<section class="licensed">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-lg-4">
            <p class="text-center pb-3"><img src="/assets/image/Frame.png" alt="photo"></p>
          </div>
          <div class="col-lg-7">
            <h3 class="licensed-header">Backed by the Best</h3>
            <p class="licensed-text">Honeycomb is rated A-Exceptional, fully licensed, and reinsured by some of the most trusted names on the planet.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row my-4">
          <div class="col-sm-4 col-4 licensed-logo"><p class="text-center"><img src="/assets/image/Vector1.png" alt="logo"></p></div>
          <div class="col-sm-4 col-4 licensed-logo"><p class="text-center"><img src="/assets/image/Vector.png" alt="logo"></p></div>
          <div class="col-sm-4 col-4 licensed-logo"><p class="text-center"><img src="/assets/image/Vector2.png" alt="logo"></p></div>
        </div>
      </div>
    </div>
  </div>
</section>



<!------------------------- motive start ------------------------------>
<section class="motive">
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-md-7 mx-auto text-center">
        <h1 class="my-4">A Better Way to Protect What Matters Most</h1>
        <p>Whether you represent an HOA or you're a property manager, building owner, or developer, we offer better coverage in a fraction of the time at a fraction of the cost. This is what we do. This is all we do. Experience the Honeycomb difference.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <img src="/assets/image/Frame1.png" class="mx-auto d-block" alt="Photo">
        <h4 class="text-center my-3"> Homeowner Associations </h4>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <img src="/assets/image/Frame2.png" class="mx-auto d-block" alt="Photo">
        <h4 class="text-center my-3"> Property Managers </h4>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <img src="/assets/image/Frame3.png" class="mx-auto d-block" alt="Photo">
        <h4 class="text-center my-3"> Developers </h4>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <img src="/assets/image/Frame4.png" class="mx-auto d-block" alt="Photo">
        <h4 class="text-center my-3"> Building Owners </h4>
      </div>
    </div>

  </div>
</section>
<!------------------------- motive end ------------------------------>


<!------------------------- customer start ------------------------------>

<section class="customer">
  <div class="container">
    <p class="text-center mb-5">From Our Customers</p>

    <div class="all-customer">
      <div class="">

        <owl-carousel-o >
          <ng-template carouselSlide>
            <div class="item">
              <div class="customer-cards  text-center">
                <p class="text-center"><img src="/assets/image/customer1.png" class="owl-image" alt="photos"></p>
                <div class="rating text-center">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <q>“Great online insurance options, with a highly attentive staff”</q>
                <div class="py-3">
                  <p><b>HOA Board Member</b></p>
                  <p>Harrisburg, PA</p>

                </div>

              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="customer-cards  text-center">
                <p class="text-center"><img src="/assets/image/customer2.png" alt="photos"></p>
                <div class="rating text-center">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <q>I got quotes really quickly, and all my questions answered</q>
                <div class="py-3">
                  <p><b>Property Manager</b></p>
                  <p>Harlingen, TX</p>

                </div>

              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="customer-cards  text-center">
                <p class="text-center"><img src="/assets/image/customer3.png" alt="photos"></p>
                <div class="rating text-center">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <q>I love that you can do things online, but also have the option to talk with a licensed agent</q>
                <div class="py-3">
                  <p><b>HOA Board Member</b></p>
                  <p>Murrells Inlet, SC</p>

                </div>

              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="customer-cards  text-center">
                <p class="text-center"><img src="/assets/image/customer1.png" alt="photos"></p>
                <div class="rating text-center">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <q>I got quotes really quickly, and all my questions answered</q>
                <div class="py-3">
                  <p><b>HOA Board Member</b></p>
                  <p>Harrisburg, PA</p>

                </div>

              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="customer-cards  text-center">
                <p class="text-center"><img src="/assets/image/customer3.png" alt="photos"></p>
                <div class="rating text-center">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <q>I love that you can do things online, but also have the option to talk with a licensed agent</q>
                <div class="py-3">
                  <p><b>HOA Board Member</b></p>
                  <p>Murrells Inlet, SC</p>

                </div>

              </div>
            </div>
          </ng-template>
        </owl-carousel-o>




      </div>

    </div>

  </div>
</section>
<!------------------------- customer end ------------------------------>


<!------------------------- promise start ------------------------------>
<section class="promise">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-md-5">
        <div class="w-75 promise-width">
          <h4 class="orange-text">The Honeycomb Promise</h4>
          <h2 class="promise-head my-3">Coverage You Can Trust</h2>
          <p>Honeycomb works directly with top A/A++ rated carries who specialize in commercial real estate insurance</p>
        </div>
      </div>
      <div class="col-md-7">
        <div class="row promise-right">
          <div class="col-md-6 mt-5">
            <img src="/assets/image/watch.png" class="d-block" alt="photo">
            <h4 class="my-3">Instant Quotes</h4>
            <p>Free, no hassle quotes at the click of a button. No more fax machines, long telephone calls with agents and long unreadable forms.</p>
          </div>

          <div class="col-md-6 mt-5">
            <img src="/assets/image/world.png" class="d-block" alt="photo">
            <h4 class="my-3">Online Everything</h4>
            <p>Access to quotes, binders, policy forms and all endorsements 24/7. Unit owners and tenants get direct access to download their insurance certificates from our site.</p>
          </div>

          <div class="col-md-6 mt-5">
            <img src="/assets/image/save.png" class="d-block" alt="photo">
            <h4 class="my-3">Up to 50% Savings</h4>
            <p>Our unique offering combines proprietary technology with unlimited expert advice to help you find the best coverage at the most affordable price.</p>
          </div>

          <div class="col-md-6 mt-5">
            <img src="/assets/image/massage.png" class="d-block" alt="photo">
            <h4 class="my-3">Unlimited Expert Advice</h4>
            <p>If you have any questions at any point of the way, our top experts would be happy jump on a phone call with you and provide tailored guidance.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!------------------------- promise end ------------------------------>




<!------------------------- control start ------------------------------>
<section class="control">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <figure>
          <img src="/assets/image/phone.png" class="img-fluid" alt="pic">
        </figure>
      </div>
      <div class="col-md-6 px-5 d-flex  align-items-center">
        <div class=" control-text">
          <h4 class="orange-text">Take Control of Your Options</h4>
          <h1 class="my-3    Fully">Fully Customizable Coverage</h1>
          <h1 class="my-3   control-content">Get Covered Faster</h1>
          <p>Our Inspector App gives you the power to get insured in a fraction of the time it takes elsewhere..</p>

          <div class="row">
            <div class="control-body">
              <div class="body-content py-3">
                <h4 class="content-head">Instant Capture</h4>
                <p>Get quotes faster by quickly providing property images</p>
              </div>
              <div class="body-content py-3 	control-content">
                <h4 class="content-head">Real-time Quotes</h4>
                <p>Get quotes faster by quickly providing property images</p>
              </div>
              <div class="body-content py-3  control-content">
                <h4 class="content-head">Guaranteed Coverage</h4>
                <p>Get quotes faster by quickly providing property images</p>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!------------------------- control end ------------------------------>



<section class="homeowner">
  <div class="container">
    <div class="row">
      <div class="col-md-4 home-right m-0 p-0 d-md-none d-block">
        <figure class="m-0">
          <img src="/assets/image/town.png" alt="photo" class="d-block d-sm-none">
          <img src="/assets/image/smtown.png" alt="photo" class="d-none d-sm-block">
        </figure>
      </div>
      <div class="col-lg-8 col-md-10 mx-auto">
        <div class="homeowner-body row">
          <div class="col-md-8 home-left m-0">
            <h6 class="mb-4">Insurance Guides</h6>
            <h2>Homeowners Association Insurance Basics</h2>
            <p class="mt-4">A must-read for HOA Board Members</p>
          </div>
          <div class="col-md-4 home-right m-0 p-0 d-md-block d-none">
            <figure>
              <img src="/assets/image/town.png" alt="photo">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-----------------------  coverage start ----------------------->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>
